var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"companyMap"},[_c('div',{staticClass:"titleWrap"},[_c('indexTitle',{attrs:{"title":_vm.title,"more":false}})],1),_c('div',{staticClass:"mapCenter",attrs:{"id":"map-container"}},[_c('svg',{ref:"svgRef"})])])}
var staticRenderFns = []

export { render, staticRenderFns }